export default {
  'operateSuccess': '操作成功'
};
